import React from 'react';
export function SectionDivider() {
  return <div className="flex items-center justify-center py-6 opacity-50" data-id="element-118">
      <div className="h-px w-16 bg-brand-line" data-id="element-119"></div>
      <span className="mx-4 text-xl" data-id="element-120">🕯️</span>
      <div className="h-px w-16 bg-brand-line" data-id="element-121"></div>
    </div>;
}